
<template>
    <div class="position-relative" style="min-height:35px;">
        <slot></slot>
    </div>
</template>

<script>
    import autoComplete from '@tarekraafat/autocomplete.js';

    export default {
        data: function () {
            return {

            };
        },
        props: ["selector"],
        mounted: function () {
            var vm = this;
            var fieldName = "label";
            const autoCompleteJS = new autoComplete({
                selector: vm.$props.selector,
                data: {
                    src: async () => {
                        document.querySelector(vm.$props.selector).setAttribute("placeholder", "טוען...");
                        const source = await fetch('/catalog/searchtermautocomplete?term=' + document.querySelector(vm.$props.selector).value);
                        const data = await source.json();
                        document.querySelector(vm.$props.selector).setAttribute("placeholder", autoCompleteJS.placeHolder);
                        return data;
                    },
                    keys: ["label"],
                    key: [fieldName],
                    //cache: true,
                },
                searchEngine: "loose",
                placeHolder: "חיפוש",
                maxResults: 5,
                highlight: true,
                debounce: 300,
                threshold: 1
            });

            document.querySelector(vm.$props.selector).addEventListener("selection", function (event) {
                var foundTerm = event.detail.selection.value["label"].trim().replace(")", "))").replace("(", ")").replace("))", "(");
                document.querySelector(vm.$props.selector).value = foundTerm;
                window.location.href = event.detail.selection.value["producturl"];
                console.log(event.detail);
            });

            document.querySelector(vm.$props.selector).addEventListener("keyup", function (event) {
                console.log(event.keyCode);
                if (event.keyCode === 13) {
                    event.preventDefault();
                    document.querySelector(vm.$props.selector + "-form").submit();
                }
            });
        },
        methods: {
        },
        computed: {
        }
    }
</script>